// @flow
import { connect } from 'react-redux';

import userActions from 'actions/user';

import ChangePasswordView from './RecoverPasswordView';

// import ChangePasswordView from './ChangePasswordView';

// Map Props
const mapStateToProps = (state) => ({
  isProcessing: state.request.isProcessing,
});

// Map Dispatch
const mapDispatchToProps = () => ({
  changePassword:
  (hash: string, newPassword: string) => userActions.changePassword(hash, newPassword),
});

// Container Component
const ChangePasswordPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChangePasswordView);

export default ChangePasswordPage;
